var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFavoriteProject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15333 2.84001L10.3267 5.18668C10.4867 5.51334 10.9133 5.82668 11.2733 5.88668L13.4 6.24001C14.76 6.46668 15.08 7.45334 14.1 8.42668L12.4467 10.08C12.1667 10.36 12.0133 10.9 12.1 11.2867L12.5733 13.3333C12.9467 14.9533 12.0867 15.58 10.6533 14.7333L8.66 13.5533C8.3 13.34 7.70667 13.34 7.34 13.5533L5.34667 14.7333C3.92 15.58 3.05333 14.9467 3.42667 13.3333L3.9 11.2867C3.98667 10.9 3.83333 10.36 3.55333 10.08L1.9 8.42668C0.926667 7.45334 1.24 6.46668 2.6 6.24001L4.72667 5.88668C5.08 5.82668 5.50667 5.51334 5.66667 5.18668L6.84 2.84001C7.48 1.56668 8.52 1.56668 9.15333 2.84001Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFavoriteProject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-favorite-project.b5386a2a0e94c5d7a5f8c3aca7c83fd9.svg";